import React from 'react';
import { translate } from '../../Services/translation';

const RelationAndGuides = (props) => {
  return (
    <>
      {props.guideTitle && (
        <div className="product-page__guide-link guide-link__wrapper guide-link__wrapper--single">
          <div className="guide-link__icon-container">
            <i className="ph-question color-grey-900"></i>
          </div>
          <div className="guide-link__content-wrapper color-grey-900">
            <div className="guide-link__title">{props.guideTitle}</div>
            <div
              className="guide-link__content"
              dangerouslySetInnerHTML={{ __html: props.guideContent?.value }}
            ></div>
          </div>
        </div>
      )}

      {/* @*if on inhousegroup - hidden in css*@ */}

      <div className="relation-and-guides">
        {props.guideTitle && (
            <div className="product-page__guide-link guide-link__wrapper bg-grey-100">
              <div className="guide-link__content-wrapper color-grey-900">
                <div className="guide-link__title">{props.guideTitle}</div>
                <div
                    className="guide-link__content"
                    dangerouslySetInnerHTML={{__html: props.guideContent?.value}}
                ></div>
              </div>
            </div>
        )}
      </div>
    </>
  );
};

export default RelationAndGuides;
